import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.Announcement.heading',
    defaultMessage: 'Komunikat o połączeniu spółek'
  }
});



// WEBPACK FOOTER //
// ./src/views/Announcement/AnnouncementView.intl.js